export enum DeleteTypeEnum {
    user = 1,
    group = 2,
    project = 3,
    event = 4,
    ad = 5,
    service = 6,
    gallery = 7
}